/**
 * @generated SignedSource<<d54aadc3a2db2673405c42e454f9baee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accessBlocked_Query$variables = {};
export type accessBlocked_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"accessBlocked_viewer">;
  } | null;
};
export type accessBlocked_Query = {
  variables: accessBlocked_Query$variables;
  response: accessBlocked_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "access_blocked"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"access_blocked\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "accessBlocked_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "accessBlocked_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "accessBlocked_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accessBlocked",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e6b84b2d002b800829213f8d6fa64d75",
    "id": null,
    "metadata": {},
    "name": "accessBlocked_Query",
    "operationKind": "query",
    "text": "query accessBlocked_Query {\n  viewer {\n    actualPersonId\n    component(name: \"access_blocked\")\n    ...accessBlocked_viewer\n    id\n  }\n}\n\nfragment accessBlocked_viewer on Viewer {\n  id\n  company {\n    id\n    accessBlocked\n  }\n}\n"
  }
};
})();

(node as any).hash = "0a3de486ca24ccf47876f50c207a3ffb";

export default node;
